import { useAppSelector } from '../../store/hooks';
import { selectIsFeatureFlagEnabled } from '../store/feature-flags.selectors';

export function useFeatureFlag(flagName: string): boolean {
  return useAppSelector(selectIsFeatureFlagEnabled(flagName));
}
